<template>
    <v-footer class="app-footer" color="white" padless >
           <v-row
            justify="center"
            no-gutters
         >
      <v-btn
        v-for="(item,i) in items"
        :key="i"
        text
        rounded
        small 
        class="my-2"
        @click="onItemClick(item)"
      >
       {{item.displayName}}
      </v-btn>
    </v-row>
         <span
            class="caption rightitem"
         >
            Copyright &copy; 2005-{{ new Date().getFullYear() }} Retail Solutions Inc. All Rights Reserved.
        </span>
        </v-footer>
</template>
<script>
export default {
    name:"AppFooter",
    computed: {
        items(){
            return this.$store.getters.getFooterItems;
        }
    },
    methods: {
        onItemClick(item) {
             window.open(item.url, "_blank");    
        },
    }
}
</script>
<style lang="scss" scoped>
    .app-footer {
        background-color: #ffffff !important;
        position: fixed !important;
        bottom: 0;
        width: 100%;
        text-align: center;
    }
   
    @media only screen and (min-width: 1300px) {
        .rightitem{
            right:0;
            position: absolute;
        }
    }
</style>
